import { useRoute } from '@react-navigation/native';
import { RootStackParamList, TypedRoute } from 'src/routes/_shared/navigation.types';

export function useTypedRoute<T extends keyof RootStackParamList>() {
  return useRoute<TypedRoute<T>>();
}
